import { Component, Input, OnInit } from '@angular/core';
import { Blacklist, Media, PlayerStatus, Playlist } from '../../../store/entities';
import { NgRedux, Select } from '@angular-redux3/store';
import { APause, APlay, APlayFromMedia, PlaylistRemoteAppState, TPlayer } from '../../../store';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { SyncDialogService } from '../../../services/sync-dialog.service';
import { map } from 'rxjs/operators';

@Component({
  selector: 'mwo-play-btn-playlist',
  templateUrl: './play-btn-playlist.component.html',
  styleUrls: ['./play-btn-playlist.component.scss']
})
export class PlayBtnPlaylistComponent implements OnInit {
  @Input() media: Media;
  isGoodMedia: boolean;
  private playerId: string;
  private eventId: string;
  @Select('wishlist') wishlist$: Observable<Playlist>;
  @Select(['player', 'isPlaying']) isPlaying$: Observable<boolean>;
  @Select('blacklist') blacklist$: Observable<Blacklist[]>;

  private wishlistId: string;
  isInBlacklist$: Observable<boolean>;

  constructor(
    private ngRedux: NgRedux<PlaylistRemoteAppState>,
    private route: ActivatedRoute,
    private syncDialogService: SyncDialogService
  ) { }

  ngOnInit() {
    this.isInBlacklist$ = this.blacklist$.pipe(
      map(blacklist => !!blacklist.find(({ media }) => media.id === this.media.id))
    );
    this.wishlist$.subscribe(wishlist => this.wishlistId = wishlist.id);
    this.ngRedux.select<PlayerStatus>('player').subscribe(({ media, player }) => {
      if (player && player.id) {
        this.playerId = player.id;
      }
      if (media) {
        this.isGoodMedia = !this.media || this.media.id === media.id;
      }
    });
  }

  play() {
    if (this.media) {
      if (this.route.snapshot.url[3]) {
        this.eventId = this.route.snapshot.url[3].path;
      } else if (this.route.snapshot.url && this.route.snapshot.url[1]) {
        this.eventId = this.route.snapshot.url[1].path;
      } else if (this.route.snapshot.url && this.route.snapshot.url[0]) {
        this.eventId = this.wishlistId;
      }
      const { data, url } = this.route.snapshot;
      if (data.context === 'MIX') {
        this.ngRedux.dispatch(APlayFromMedia({
          player: {
            id: this.playerId
          },
          tempo: {
            id: this.eventId
          },
          media: {
            id: this.media.id
          },
          playerContextType: data.context,
          shuffle: false,
          type: TPlayer.PLAY_FROM
        }));
        this.syncDialogService.openSyncDialog('MEDIA_TEMPO');
      } else {
        this.ngRedux.dispatch(APlayFromMedia({
          player: {
            id: this.playerId
          },
          event: {
            id: this.eventId
          },
          media: {
            id: this.media.id
          },
          playerContextType: data.context,
          shuffle: false,
          type: TPlayer.PLAY_FROM
        }));
        this.syncDialogService.openSyncDialog('MEDIA_EVENT');
      }
    } else {
      this.ngRedux.dispatch(APlay());
      this.syncDialogService.openSyncDialog('PLAY');
    }
  }

  pause() {
    this.ngRedux.dispatch(APause());
    this.syncDialogService.openSyncDialog('PAUSE');
  }
}
